module.exports = __webpack_public_path__ + "img/aquabot.e6e54c2a.jpg";